var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 2.625C20.5359 2.625 20.4445 2.64141 20.3531 2.67891L6.84375 8.10703H3C2.79375 8.10703 2.625 8.28047 2.625 8.49609V15.5039C2.625 15.7195 2.79375 15.893 3 15.893H5.38125C5.29453 16.1648 5.25 16.4531 5.25 16.7461C5.25 18.2906 6.51094 19.5469 8.0625 19.5469C9.36094 19.5469 10.4555 18.6656 10.7789 17.475L20.3555 21.3234C20.4469 21.3586 20.5383 21.3773 20.6273 21.3773C21.0234 21.3773 21.3773 21.0445 21.3773 20.5992V3.40312C21.375 2.95781 21.0234 2.625 20.625 2.625ZM8.0625 17.8664C7.44141 17.8664 6.9375 17.3648 6.9375 16.7461C6.9375 16.4836 7.02891 16.2328 7.19531 16.0336L9.18516 16.8328C9.13828 17.4094 8.65312 17.8664 8.0625 17.8664Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFilled);
export default __webpack_public_path__ + "static/media/notification-filled.ec1615e0181e23c8d8e6baa6312d44f4.svg";
export { ForwardRef as ReactComponent };